import { createSelector } from '@reduxjs/toolkit';
import { convertDateFromStateToISO } from '@che-ins-ui/datepicker';
const flightsSelector = (state) => state.flights.flights;
export const flightsFormsSelector = createSelector([flightsSelector], (flights) => flights);
export const flightsForApiSelector = createSelector([flightsSelector], (flights) => flights.map(({ airline, flightNumber, from, to, dateFrom, dateTo, timeFrom, timeTo, fieldsErrors, }) => ({
    airline: fieldsErrors.airline ? '' : airline,
    flightNumber: fieldsErrors.flightNumber ? '' : flightNumber,
    from: fieldsErrors.from ? '' : from,
    to: fieldsErrors.to ? '' : to,
    dateFrom: fieldsErrors.dateFrom
        ? ''
        : convertDateFromStateToISO(dateFrom),
    dateTo: fieldsErrors.dateTo
        ? ''
        : convertDateFromStateToISO(dateTo),
    timeFrom: fieldsErrors.timeFrom ? '' : timeFrom,
    timeTo: fieldsErrors.timeTo ? '' : timeTo,
})));
export const isFlightsValidatedSelector = createSelector([(state) => state.flights.isFlightsValidated], (isFlightsValidated) => isFlightsValidated);
export const isFlightsDirtySelector = createSelector([(state) => state.flights.isFlightsDirty], (isFlightsDirty) => isFlightsDirty);
export const flightsStepErrorSelector = createSelector([(state) => state.flights.stepError], (stepError) => stepError);
export const flightsStepErrorTypeSelector = createSelector([(state) => state.flights.stepErrorType], (stepErrorType) => stepErrorType);
